<acl-ngx-page-header>
    <!--Plan Details-->
    <acl-ngx-page-header-section contentClass="header-content">
        <div class="row">
            <div class="col-4">
                <label>Plan</label>
                <h4 class="planName">{{ planDetails?.name }}</h4>
                <!--Plan Autocomplete-->
                <auto-complete [endpointUrl]="autoCompletetConfig.plannerEndpoint" width="500px" [buttonTrigger]="true"
                    [responseMapper]="autoCompletetConfig.responseMapper"
                    (onSelect)="autoCompletetConfig.handleOnPlannerSelect($event)">
                </auto-complete>
            </div>
            <!--Action Buttons-->
            <div class="col-2">
                <div class="row action-buttons">
                    <acl-ngx-button icon="Copy" title="Copy Plan" (click)="copyAction()" dark="true" variant="static"
                        compact="true">
                    </acl-ngx-button>
                </div>
            </div>
            <!--Header Data Field-->
            <div class="data-field-header col-6">
                <div class="row">
                    <div class="data-field col-5">
                        <label>Generated</label>
                        <h5>{{generatedDate | timezone : 'L' : planDetails.marketTimeZone}}
                            {{generatedDate | timezone : 'LT' : planDetails.marketTimeZone}}</h5>
                    </div>
                    <ng-container *ngIf="overallPerformanceForecastData">
                        <div class="data-field col-5">
                            <label>Flight</label>
                            <h5>
                                {{overallPerformanceForecastData.flightSchedule.startDate | timezone : 'L' :
                                planDetails.marketTimeZone}}
                                -
                                {{overallPerformanceForecastData.flightSchedule.endDate | timezone : 'L' :
                                planDetails.marketTimeZone}}
                            </h5>
                        </div>
                        <div class="data-field col-2">
                            <label>Budget</label>
                            <h5>
                                {{overallPerformanceForecastData.flightSchedule.spendingCap | currency :
                                planDetails.currency : 'symbol' : '1.2-10'}}
                            </h5>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </acl-ngx-page-header-section>
</acl-ngx-page-header>
<!--Dashboard Content-->
<div class="table-wrapper">
    <div>
        <acl-ngx-collapsible-nav>
            <acl-collapsible-nav-items-wrapper [collapsibleNavItems]="collapsibleItems">
            </acl-collapsible-nav-items-wrapper>
        </acl-ngx-collapsible-nav>
    </div>
    <div class="planner-dashboard-body container-fluid">
        <div *ngIf="currentDashBoardType == plannerDashboardType.DigitalVideo">
            <!--Performance Forecast-->
            <div class="performance-forecast">
                <performance-forecast [overallPerformanceForecastData]="overallPerformanceForecastData"
                    [goalPerformanceForeCastData]="goalPerformanceForeCastData" [planDetails]="planDetails">
                </performance-forecast>
            </div>
            <!--Funnel-->
            <div class="forecast-blueprint">
                <forecast-blueprint [funnelData]="funnelData"></forecast-blueprint>
            </div>
            <!--Inventory Allocation-->
            <div class="inventory-allocation">
                <inventory-allocation [privateDeals]="privateDeals" [planDetails]="planDetails" [total]="total"
                    [openAuction]="openAuction" [guaranteedDeals]="guaranteedDeals">
                </inventory-allocation>
            </div>
        </div>
        <!--Insertion Order Preview-->
        <div class="io-preview" *ngIf="currentDashBoardType == plannerDashboardType.IOPreview && ioPreviewData">
            <io-preview [ioPreviewData]="ioPreviewData" [planDetails]="planDetails" [openAuction]="openAuction">
            </io-preview>
        </div>
    </div>
</div>
<amobee-loader *ngIf="waitingForActivation" loading="true"></amobee-loader>